export let reportAndBlockButton = "k7TXbd";
export let blockActionText = "qGVSEc";
export let reportAndUnsubscribeButton = "WONGFc";
export let unsubscribeActionText = "Osa0Td";
export let confirmReportButton = "gWedne";
export let reportJunkTitle = "GQA5Wd";
export let reportJunkContent = "JNCvhe";
export let removeFromJunkV2 = "IOMqEe";
export let removeFromJunkEnterpriseMessageBodySingleSenderSelected = "WxPjUc";
export let removeFromJunkEnterpriseMessageBodyTwoSendersSelected = "fNeFhb";
export let removeFromJunkEnterpriseMessageBodyThreeSendersSelected = "hPP7Pb";
export let removeFromJunkEnterpriseMessageBodyFourPlusSendersSelected = "x4FVme";
export let reportPhishingContent = "v_DWq";
export let reportPhishingTitle = "EpoNg";
export let reportUnsubscribeBlock = "WqnMxc";
export let reportBlockExternal = "Ap5eHc";
export default {reportAndBlockButton,blockActionText,reportAndUnsubscribeButton,unsubscribeActionText,confirmReportButton,reportJunkTitle,reportJunkContent,removeFromJunkV2,removeFromJunkEnterpriseMessageBodySingleSenderSelected,removeFromJunkEnterpriseMessageBodyTwoSendersSelected,removeFromJunkEnterpriseMessageBodyThreeSendersSelected,removeFromJunkEnterpriseMessageBodyFourPlusSendersSelected,reportPhishingContent,reportPhishingTitle,reportUnsubscribeBlock,reportBlockExternal};